"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromGitHubOrg = void 0;
function fromGitHubOrg(org) {
    if (!(org && org.id))
        return null;
    return {
        id: org.id,
        nodeId: org.node_id || '',
        login: org.login || '',
        avatarUrl: org.avatar_url || '',
        type: org.type || 'Organization',
    };
}
exports.fromGitHubOrg = fromGitHubOrg;
//# sourceMappingURL=organization.js.map